import { motion } from "framer-motion";
import { PageSEO } from "@/components/PageSEO";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="pt-16 lg:pt-20">
      <PageSEO
        title="Terms of Service"
        description="Website terms of use for Your-IT-Solutions. Read our terms covering intellectual property, liability, and usage conditions."
        path="/terms"
      />
      <section className="py-20 lg:py-28 hero-gradient relative overflow-hidden">
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="text-cyan-400 text-sm font-medium uppercase tracking-widest mb-4 block">Legal</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
              Terms of <span className="gradient-text">Service</span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose-custom space-y-10">
            <p className="text-gray-400 leading-relaxed">
              By accessing and using this website, you agree to the following terms and conditions.
            </p>

            <div>
              <h2 className="text-xl font-semibold text-white mb-3">1. Intellectual Property</h2>
              <p className="text-gray-400 leading-relaxed">
                All content on this website is owned by Your-IT-Solutions. You may not copy or reuse content without written permission.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-3">2. Limitation of Liability</h2>
              <p className="text-gray-400 mb-3">We are not liable for:</p>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-500 mt-1.5 block w-1.5 h-1.5 rounded-full bg-cyan-500 flex-shrink-0" />
                  Website downtime or interruptions
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-500 mt-1.5 block w-1.5 h-1.5 rounded-full bg-cyan-500 flex-shrink-0" />
                  Third-party services or links
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-500 mt-1.5 block w-1.5 h-1.5 rounded-full bg-cyan-500 flex-shrink-0" />
                  Loss of data or revenue arising from use of the website
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-3">3. Disclaimer</h2>
              <p className="text-gray-400 leading-relaxed">
                Information on this website is provided "as is" without warranty of any kind, express or implied.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-3">4. Changes to Terms</h2>
              <p className="text-gray-400 leading-relaxed">
                We reserve the right to update these terms at any time. Continued use of the website constitutes acceptance of any changes.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-3">5. Contact</h2>
              <p className="text-gray-400 leading-relaxed">
                If you have questions about these terms, contact us at:{" "}
                <a href="mailto:contact@your-it-solutions.com" className="text-cyan-400 hover:text-cyan-300 transition-colors">
                  contact@your-it-solutions.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
